module.exports = __webpack_public_path__ + "img/ck_research.d18ac09c.svg";